<template>
  <section class="address">
    <ServerDisconnectConfirm
      v-if="serverDeleteConfirmOpened"
      :loading="$store.getters.isLoading"
      :server-name="srvr.name"
      @close="onServerDeleteConfirmClose"
      @approve="onServerDeleteConfirmApprove"
    />
    <ServerPopup
      v-if="serverPopup.opened"
      v-model="serverPopup.modelValue"
      :mode="serverPopup.mode"
      @close="onServerPopupClose"
      @approve="onServerPopupApprove"
    />
    <Popup
      v-if="clientPopup.opened"
      title="Редактировать доступы"
      :minBodyHeight="clientPopup.minBodyHeight"
      @close="onClientPopupClose"
      @approve="onClientPopupApprove"
    >
      <Select
        v-model="clientPopup.value"
        :mode="clientPopup.mode"
        :options="clientPopup.options"
        :placeholder="clientPopup.placeholder"
        :multipleLabel="clientPopup.multipleLabel"
        :closeOnSelect="false"
        @open="onSelectOpen"
        @close="onSelectClose"
      />
      <small style="color: red; font-size: 12px" v-if="clientPopup.error">
        Следующие доступы не могут назначаться вместе с другими:
        <b>{{ clientPopup.restrictedRules.join(',') }}</b>
      </small>
    </Popup>
    <Header class="address__header">
      <template v-slot:title>Сервер {{ srvr.name }}</template>
      <template v-slot:addons>
        <Chips :chips="srvr.status ? [srvr.chips[0]] : [srvr.chips[1]]" />
      </template>
    </Header>

    <BackButton router-page-name="Gates" class="address__back">
      Назад к контролям доступа
    </BackButton>
    <Header class="address__subheader" type="h4">
      <template v-slot:title> Адреса </template>
    </Header>
    <div class="address__filters">
      <Filters v-model="filtersActive" :filters="filters" />
    </div>
    <div class="address__list">
      <Table
        v-model="rowsSelected"
        :columns="tableColumns"
        :rows="tableRows"
        @switcherClick="onSwitcherClick"
        @rowClick="onRowClick"
      />
      <Pagination
        v-model="currentPage"
        v-bind="pagination"
        @switchPage="onSwitchPage"
      />
    </div>
    <div class="address__actions">
      <Actions
        :actions="rowsSelected.length ? actions.selected : actions.default"
      />
    </div>
  </section>
</template>

<script>
import Header from '../../components/Header.vue'
import Filters from '../../components/Filters.vue'
import Table from '../../components/Table.vue'
import Actions from '../../components/Actions.vue'
import MockGateServer from '../../mixins/Mock/MockGateServer.js'
import IconBase from '../../components/Icons/IconBase.vue'
import Chips from '../../components/Chips.vue'
import ServerPopup from '../Popup/Server.vue'
import MockPagination from '../../mixins/Mock/MockPagination.js'
import Pagination from '../../components/Pagination.vue'
import BackButton from '../../components/BackButton.vue'
import Select from '../../components/Form/Select.vue'
import Popup from '../../components/Popup.vue'
import ServerDisconnectConfirm from '../Popup/ServerDisconnectConfirm.vue'

export default {
  name: 'AddressList',
  mixins: [MockGateServer, MockPagination],
  components: {
    Header,
    Filters,
    Table,
    Actions,
    IconBase,
    Chips,
    ServerPopup,
    Pagination,
    BackButton,
    Select,
    Popup,
    ServerDisconnectConfirm,
  },
  data() {
    return {
      filtersActive: {},
      rowsSelected: [],
    }
  },
  watch: {
    filtersActive: {
      handler(value) {
        this.filterContacts({
          ...value,
          status: value.status ?? '',
        })
      },
      deep: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.address {
  width: 100%;

  &__header,
  &__filters,
  &__back,
  &__list {
    margin: 0px $space-md $space-lg;
  }

  &__subheader {
    margin: $space-xl $space-md $space-lg;
  }
}
</style>
